import { userInfoSync } from 'hub-http/userInfo';
import { useAppSelector } from '../store/rootReducer';
export function useAuth() {
  const auth = useAppSelector(state => state.auth);
  const userInfo = userInfoSync();
  return Object.assign({}, auth, userInfo);
}